// Snake — garbage bet. The last player to three-putt "holds the snake" and
// pays. GolfGamesScorecard tracks three-putts in the UI and routes 'snake' to
// calcStroke for standings (no canonical engine). We mirror that: calcStroke
// standings (imported) + a zero-sum settlement where the final snake-holder
// pays `amount` to every other player.
export { calcStroke } from './ggStrokePlay.js'

/**
 * Settle the snake. threePutts: ordered [{ hole, playerId }].
 *   model 'last'  — the LAST three-putter holds the snake and pays `amount`
 *                   to every other player (default; back-compatible).
 *   model 'fixed' — EACH three-putt, the offender pays `amount` to every other
 *                   player (every three-putt is penalized). Both zero-sum.
 * Returns { holder, model, payouts, threePutts }.
 */
export function computeSnake(players, threePutts = [], amount = 0, { model = 'last' } = {}) {
  const ids = (players || []).map((p) => p.id)
  const payouts = {}
  ids.forEach((id) => { payouts[id] = 0 })
  const amt = Number(amount) || 0
  const charge = (offender) => {
    if (payouts[offender] == null) return
    ids.forEach((id) => { if (id !== offender) { payouts[id] += amt; payouts[offender] -= amt } })
  }
  const holder = threePutts.length ? threePutts[threePutts.length - 1].playerId : null
  if (amt > 0) {
    if (model === 'fixed') threePutts.forEach((ev) => charge(ev.playerId))
    else if (holder) charge(holder)
  }
  return { holder, model, payouts, threePutts }
}

/** One-tap 3-putt markers → ordered event list (auto input). */
export function threePuttsFromMarkers(markers = []) {
  return [...markers].filter((m) => m && m.playerId != null).sort((a, b) => a.hole - b.hole)
}

/** Per-hole putts grid { pid: number[18] } → 3-putt events (≥3 putts), hole-ordered. */
export function threePuttsFromPutts(players, puttsByPlayer = {}) {
  const events = []
  for (let h = 0; h < 18; h++) {
    for (const p of players || []) {
      const pu = puttsByPlayer[p.id]?.[h]
      if (pu != null && pu >= 3) events.push({ hole: h, playerId: p.id })
    }
  }
  return events
}

// ── Auto-settle (ON): derive the holder from entered 3-putt markers ──────────
export function autoSnake(players, markers, amount = 0, { model = 'last' } = {}) {
  return computeSnake(players, threePuttsFromMarkers(markers), amount, { model })
}

// ── Manual (OFF, fallback): settle from the holder you tracked yourself ──────
export function manualSnake(players, holderId, amount = 0) {
  return computeSnake(players, holderId ? [{ hole: 0, playerId: holderId }] : [], amount, { model: 'last' })
}
